import { render, staticRenderFns } from "./LeadsStorage.vue?vue&type=template&id=53ea2816&scoped=true"
import script from "./LeadsStorage.vue?vue&type=script&lang=js"
export * from "./LeadsStorage.vue?vue&type=script&lang=js"
import style0 from "./LeadsStorage.vue?vue&type=style&index=0&id=53ea2816&prod&lang=css"
import style1 from "./LeadsStorage.vue?vue&type=style&index=1&id=53ea2816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea2816",
  null
  
)

export default component.exports